import { useInfiniteQuery } from '@tanstack/react-query'
import { buildQuery, useApi } from './client'

export type AuditEntityType =
  | 'transactions'
  | 'licenses'
  | 'license_tariffs'
  | 'license_payments'
  | 'invoices'
  | 'invoice_payments'
export type AuditAction = 'create' | 'update' | 'delete'

export type AuditEntry = {
  id: string
  userId: string | null
  userEmail: string | null
  entityType: AuditEntityType
  entityId: string
  action: AuditAction
  before: unknown
  after: unknown
  createdAt: string
}

export type AuditFilters = {
  entityType?: AuditEntityType | null
  entityId?: string | null
  userId?: string | null
  action?: AuditAction | null
  dateFrom?: string | null
  dateTo?: string | null
}

type Page = { items: AuditEntry[]; nextCursor: string | null }

export function useAuditLog(filters: AuditFilters) {
  const api = useApi()
  return useInfiniteQuery({
    queryKey: ['audit-log', filters],
    initialPageParam: null as string | null,
    queryFn: ({ pageParam }) => {
      const qs = buildQuery({
        entity_type: filters.entityType ?? undefined,
        entity_id: filters.entityId ?? undefined,
        user_id: filters.userId ?? undefined,
        action: filters.action ?? undefined,
        date_from: filters.dateFrom ?? undefined,
        date_to: filters.dateTo ?? undefined,
        cursor: pageParam ?? undefined,
        limit: 50,
      })
      return api<Page>(`/audit-log${qs}`)
    },
    getNextPageParam: (last) => last.nextCursor,
  })
}
